export const B2B_SUBSCRIPTIONS_MVP_FEATURE_FLAG = 'loyaltyB2bSubscriptionMvp';
export const B2B_SUBSCRIPTIONS_RECRUITMENT_TOUCHPOINT_NO_MODAL_AB_TEST =
  'loyaltySuperProRecruitmentNoModal';

export const B2B_SUBSCRIPTION_PORTAL_ENDPOINT =
  '/payment-operations/api/v1/subscriptions/portal';

export const B2B_SUBSCRIPTION_CANCEL_ENDPOINT =
  '/payment-operations/api/v1/subscriptions/cancel';

// Default values for prices in case the prices in the BO are not set correctly
export const defaultMonthlyValue = 59;
